import { render, staticRenderFns } from "./ModalEditGrup.vue?vue&type=template&id=6a1d9d5f&scoped=true&"
import script from "./ModalEditGrup.vue?vue&type=script&lang=js&"
export * from "./ModalEditGrup.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditGrup.vue?vue&type=style&index=0&id=6a1d9d5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1d9d5f",
  null
  
)

export default component.exports